import { isCancel as m, AxiosError as h } from "axios";
import { AccessDenied as p } from "./index3.mjs";
import { BadRequest as u, BadRequestWithViolations as R } from "./index4.mjs";
import { ConflictError as l } from "./index5.mjs";
import { FailedDependency as E } from "./index8.mjs";
import { InternalError as g } from "./index9.mjs";
import { invalidTokenErrorMessages as k } from "./index10.mjs";
import { LockedError as T } from "./index11.mjs";
import { NetworkError as y } from "./index12.mjs";
import { NotFound as i } from "./index13.mjs";
import { PayloadTooLarge as q } from "./index14.mjs";
import { UnauthorizedResponse as F } from "./index15.mjs";
import { UnprocessableContentError as N } from "./index16.mjs";
const I = (a, n) => {
  let o = !1, r = [];
  const c = () => a.post("/api/user/token/regenerate"), w = (t) => {
    r.push(t);
  }, d = () => {
    r.forEach((t) => t()), r = [];
  }, f = async (t) => {
    const e = t.config;
    if (!o) {
      o = !0;
      try {
        return await c(), o = !1, d(), await a(e);
      } catch (s) {
        throw o = !1, r = [], s;
      }
    }
    return new Promise((s) => {
      w(() => {
        s(a(e));
      });
    });
  };
  return async (t) => {
    if (m(t))
      throw t;
    if (t = t, t.code === h.ERR_NETWORK)
      throw new y();
    const e = t.response;
    if (!e)
      throw t;
    switch (e.status) {
      case 400:
        throw "errors" in e.data ? new u(e.data) : new R(e.data);
      case 401:
        if (k.includes(e.data.message))
          return await f(t);
        if (e.data.location)
          throw new F(e.data.location);
        n == null || n.error("Unauthorized response", e.data);
        break;
      case 403:
        throw new p();
      case 404:
        throw new i(i.isNotFoundResponse(e.data) ? e.data : void 0);
      case 409:
        throw new l(e.data);
      case 413:
        throw new q();
      case 422:
        throw new N(e.data);
      case 423:
        throw new T();
      case 424:
        throw new E(e.data.title);
      case 500:
      case 502:
        throw new g();
    }
    throw t;
  };
};
export {
  I as getErrorMapper
};
